import React, { useEffect, useState } from 'react';
import { CalendarClock, Loader2, ArrowRight } from 'lucide-react';
import { Container } from '../components/ui';
import PageHero from '../components/PageHero';
import LeadForm from '../components/LeadForm';
import { bookingConfig } from '../lib/marketingApi';

export default function BookACall() {
  const [cfg, setCfg] = useState(null);
  const [teamId, setTeamId] = useState(null);

  useEffect(() => {
    bookingConfig().then((d) => { setCfg(d); setTeamId(d.default_team_id); }).catch(() => setCfg({ teams: [] }));
  }, []);

  const teams = cfg?.teams || [];
  const active = teams.find((t) => t.id === teamId) || teams[0] || null;

  return (
    <div data-testid="book-a-call-page">
      <PageHero eyebrow="Talk to us" title="Book a call with BillPortal"
        subtitle="Pick a time that suits you for a no-slides walkthrough on your own portfolio." />
      <section className="px-5 py-14 sm:px-8 sm:py-16">
        <Container>
          {cfg === null ? (
            <div className="flex justify-center py-24"><Loader2 className="h-6 w-6 animate-spin text-brand" /></div>
          ) : teams.length > 0 && active ? (
            <div className="mx-auto max-w-4xl">
              {teams.length > 1 && (
                <div className="mb-5 flex flex-wrap items-center justify-center gap-2" data-testid="book-team-picker">
                  {teams.map((t) => (
                    <button key={t.id} onClick={() => setTeamId(t.id)} data-testid={`book-team-${t.id}`}
                      className={`rounded-full px-4 py-2 text-sm font-semibold transition-colors ${active.id === t.id ? 'bg-brand text-white' : 'border border-slate-300 text-slate-600 hover:border-brand dark:border-white/15 dark:text-slate-300'}`}>
                      {t.name}
                    </button>
                  ))}
                </div>
              )}
              {cfg.instructions && <p className="mb-4 text-center text-sm text-slate-500 dark:text-slate-400">{cfg.instructions}</p>}
              <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white dark:border-white/10">
                <iframe title="Book a call" src={active.scheduler_url} data-testid="book-scheduler-iframe" className="h-[720px] w-full" style={{ border: 0 }} />
              </div>
              <p className="mt-4 text-center text-sm text-slate-500">
                <a href={active.scheduler_url} target="_blank" rel="noreferrer" data-testid="book-scheduler-fallback" className="inline-flex items-center gap-1 font-semibold text-brand hover:underline">
                  Open the scheduler in a new tab <ArrowRight className="h-4 w-4" />
                </a>
              </p>
            </div>
          ) : (
            <div className="mx-auto max-w-xl" data-testid="book-callback-fallback">
              <div className="mb-6 rounded-2xl border border-slate-200 bg-slate-50 p-5 text-center dark:border-white/10 dark:bg-white/[0.03]">
                <CalendarClock className="mx-auto h-8 w-8 text-brand" />
                <h3 className="mt-3 font-display text-lg font-bold text-slate-900 dark:text-white">Request a callback</h3>
                <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">Leave your details and preferred time — we'll send you a booking link to lock in a slot.</p>
              </div>
              <LeadForm source="book_a_call" submitLabel="Request a callback" callbackDefault />
            </div>
          )}
        </Container>
      </section>
    </div>
  );
}
